import { useCallback } from 'react';
import { BUYING_PATH } from 'data/global';
import { getBuyingPortfolio, getSellingPortfolio } from 'utils';
import { useLocation } from 'react-router-dom';

type UseMessagingType = {
  listingId: string;
  dealRoomId: string;
  listingEnquiryId: string;
};

export default function useMessaging(config: UseMessagingType) {
  const { listingId, dealRoomId, listingEnquiryId } = config;

  const { pathname } = useLocation();

  const isBuying = pathname.includes(BUYING_PATH);

  const getNavigationLink = useCallback(
    (sessionId = '') => {
      const isPortfolio = listingId && dealRoomId;

      if (!isPortfolio) return `/dash/messaging/${sessionId}`;

      let messagingPrefix;

      if (isBuying) messagingPrefix = getBuyingPortfolio(listingEnquiryId);
      else messagingPrefix = getSellingPortfolio(dealRoomId);

      return `${messagingPrefix}/messaging/${sessionId}`;
    },
    [dealRoomId, isBuying, listingEnquiryId, listingId],
  );

  return { getNavigationLink };
}
